import React from 'react';
import { connect } from 'react-redux';
import InternationalShippingModal from 'tradera-components/international-shipping-modal/international-shipping-modal';
import { INTERNATIONAL_SHIPPING_MODAL_ID } from 'tradera-components/international-shipping-modal/constants';
import {
    InternationalIdentificationModal,
    internationalIdentificationModalId
} from 'tradera-components/international-identification-modal/international-identification-modal';

const ModalRenderer = props => (
    <div>
        {
            {
                [INTERNATIONAL_SHIPPING_MODAL_ID]: (
                    <InternationalShippingModal />
                ),
                [internationalIdentificationModalId]: (
                    <InternationalIdentificationModal />
                )
            }[props.currentModal]
        }
    </div>
);

export default connect(state => state.ui.modals)(ModalRenderer);

export { ModalRenderer };
